import React from 'react';
import cl from "./ArtistItem.module.css";
import {Avatar} from "@mui/material";

const ArtistItem = ({id, title, subtitle, uptitle, selected, onClick, avaUrl}) => {
    return (
        <div className={cl.main}>
            <button
                className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
                onClick={onClick}
            >
                <Avatar
                    variant="square"
                    sx={{width: "105px", height: "105px", position: "absolute", right: "5px", top: "0px", borderRadius:"4px", border: (selected ? "1px solid #00000080" : "1px solid #00000020")}}
                    src={avaUrl ? avaUrl : undefined}
                >
                    <p className={cl.photoText}>Нет фото</p>
                </Avatar>
                <p className={cl.id}>{id}</p>
                <div className={cl.titleArea}>
                    <div className={cl.titleBlock}>
                        {uptitle && <p className={cl.uptitle}>{uptitle}</p>}
                        <p className={cl.title}>{title}</p>
                        {subtitle && <p className={cl.subtitle}>{subtitle}</p>}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default ArtistItem;